/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Catalog_Movement_LungeInputs */

const en_us2_catalog_movement_lunge = /** @type {(inputs: Catalog_Movement_LungeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`single-leg`)
};

const pt_br2_catalog_movement_lunge = /** @type {(inputs: Catalog_Movement_LungeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`unilateral de pernas`)
};

const es_419_catalog_movement_lunge = /** @type {(inputs: Catalog_Movement_LungeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pierna unilateral`)
};

const pt_pt2_catalog_movement_lunge = /** @type {(inputs: Catalog_Movement_LungeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`unilateral de pernas`)
};

const fr_fr2_catalog_movement_lunge = /** @type {(inputs: Catalog_Movement_LungeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`unilatéral jambes`)
};

const de_de2_catalog_movement_lunge = /** @type {(inputs: Catalog_Movement_LungeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`einbeinige Übungen`)
};

const it_it2_catalog_movement_lunge = /** @type {(inputs: Catalog_Movement_LungeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`gambe unilaterale`)
};

/**
* | output |
* | --- |
* | "single-leg" |
*
* @param {Catalog_Movement_LungeInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const catalog_movement_lunge = /** @type {((inputs?: Catalog_Movement_LungeInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Catalog_Movement_LungeInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_catalog_movement_lunge(inputs)
	if (locale === "es-419") return es_419_catalog_movement_lunge(inputs)
	if (locale === "pt-PT") return pt_pt2_catalog_movement_lunge(inputs)
	if (locale === "fr-FR") return fr_fr2_catalog_movement_lunge(inputs)
	if (locale === "de-DE") return de_de2_catalog_movement_lunge(inputs)
	if (locale === "it-IT") return it_it2_catalog_movement_lunge(inputs)
	return en_us2_catalog_movement_lunge(inputs)
});
export { catalog_movement_lunge as "catalog.movement.lunge" }